








































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';
import Contactos from './Contactos.vue';
import CurpValidate from '@/util/curp';

export default Vue.extend({
  components: {
    Contactos,
  },
  props: {
    datos: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    datosPropietario: [],
  }),
  mounted() {
    console.log('Editar propiet mounted datos', this.datos);
    this.datosPropietario = JSON.parse(JSON.stringify(this.datos));
  },
  methods: {
    async EditarPropiet() {
      this.openDialog = false;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const propietario = {
        lastModificationUsername: this.$store.getters.getUsername,
        lastModificationDateTime: this.$moment().format(),
        ...this.datosPropietario[0],
      };
      // console.log('Propietario: ', propietario);
      // console.log('username: ', this.$store.getters.getUsername;);
      const datos = {admin, condo, propietario};
      const result = await this.$store.dispatch('updatePropietario', datos);
      // console.log('result: ', result);
      this.$emit('reload');
    },
    cancel() {
      this.openDialog = false;
      this.datosPropietario = JSON.parse(JSON.stringify(this.datos));
    },
  },
  watch: {
    datos() {
      // console.log('EditarPropiet watch datos: ', this.datos);
      this.datosPropietario = JSON.parse(JSON.stringify(this.datos));
    },
  },
});
